var React = require('react');

function ChevronFaqSummit (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"25.6691","cy":"26.056","r":"24.3309","stroke":"#503CAB","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M17.4125 22.9463L25.6691 31.1656L33.9257 22.9463","stroke":"#503CAB","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ChevronFaqSummit.defaultProps = {"width":"51","height":"52","viewBox":"0 0 51 52","fill":"none"};

module.exports = ChevronFaqSummit;

ChevronFaqSummit.default = ChevronFaqSummit;
